import { CLIENT_ID, PROJECT_ID, PROJECT_NAME } from "apis/constants";

const INITIAL_DATASETS = [
  {
    id: 100,
    filename: "Renal Failure CSV",
    rowCount: 614,
    columnCount: 13,
    link: "../data-science/quality-analysis/approachable-ai",
  },
];

const RENAL_DATASET = {
  dataset_name: "renal_failure",
  project_id: "5d32dc58-4b3c-4736-8818-cbdc89514f21",
  client_id: "aadc8add-e29e-476d-bd4d-cea9c9bc019a",
};

const LOCAL_DATASET = datasetName => ({
  dataset_name: `landing/${PROJECT_NAME}/${datasetName}`,
  project_id: PROJECT_ID,
  client_id: CLIENT_ID,
});

export { INITIAL_DATASETS, RENAL_DATASET, LOCAL_DATASET };
